module.exports = __webpack_public_path__ + "img/logo-v2.5badf848.svg";